import React from 'react';


import iconTick from 'images/icon-tick.svg';

import 'css/Tick.css';

export default function Tick() {
    return (
        <img className='Tick' src={iconTick} alt="" />
    );
}


// WEBPACK FOOTER //
// ./src/components/Tick.js